import { Component } from '@angular/core';

@Component({
  selector: 'app-arrow-left-icon',
  standalone: true,
  templateUrl: './arrow-left-icon.component.html',
})
export class ArrowLeftIconComponent {}
